export default "__VITE_ASSET__CWxt0wHI__"